import React, { type FC } from 'react'
import { styled } from '@linaria/react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { colors } from '../styles/colors'
import { Typography, fontSize } from './Typography'

interface MarkdownProps {
  children: string
  className?: string
}

export const Markdown: FC<MarkdownProps> = ({ children, className }) => {
  return (
    <Container fontSize={14} className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </Container>
  )
}

const Container = styled(Typography)`
  color: ${colors.textPrimary};

  /* Spacing between paragraphs and lists */
  > * + * {
    margin-top: 12px;
  }

  /* Links */
  a {
    color: ${colors.secondary};
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  /* Bold */
  strong {
    font-weight: 600;
  }

  /* Italic */
  em {
    font-style: italic;
  }

  /* Lists */
  ul {
    margin: 0;
    padding-left: 20px;
    list-style-type: disc;
  }

  ol {
    margin: 0;
    padding-left: 20px;
    list-style-type: decimal;
  }

  li {
    margin: 4px 0;
  }

  /* Inline code */
  code {
    background: ${colors.grey100};
    padding: 2px 6px;
    border-radius: 4px;
    font-size: ${fontSize[13]};
  }

  /* Code blocks */
  pre code {
    display: block;
    padding: 12px;
    border-radius: 8px;
    overflow-x: auto;
  }
`
